import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { clearAppCache, unregisterServiceWorker } from './utils/pwa';
import './styles/mobile.css';

// ==========================================
// SAAS TENANT YÖNETİMİ VE DİNAMİK YAPILANDIRMA
// URL'den 'site.com/beykoz' kısmındaki 'beykoz' bilgisini alır
// ==========================================
const pathParts = window.location.pathname.split('/').filter(Boolean);
// Sisteme ait özel root kelimeleri değilse (login, admin vb.) ilk kısmı Müşteri (Tenant) ID kabul eder
const excludedRoots = ['dashboard', 'login', 'admin', 'panel', 'static'];
let tenantName = pathParts.length > 0 ? pathParts[0] : null;

if (tenantName && excludedRoots.includes(tenantName.toLowerCase())) {
  tenantName = null;
}

const fallbackConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

async function initializeSaaSApp() {
  if (tenantName) {
    // İleride bu satırda Master Sunucudan Müşterinin Firebase (SaaS) ayarları JSON olarak fetch edilecek:
    // const res = await fetch(`https://master.sistem.com/api/get-tenant?id=${tenantName}`);
    // const remoteConfig = await res.json();

    // Şimdilik sistemin bozulmaması için mevcut fallbackConfig'i atıyoruz.
    window.__FIREBASE_CONFIG__ = fallbackConfig;
    window.__TENANT_ID__ = tenantName;
    window.__ROUTER_BASENAME__ = `/${tenantName}`;
    console.log(`[SaaS Master] Dinamik Müşteri Kurulumu Yüklendi. Tenant: ${tenantName}`);
  } else {
    // Normal ana/default sistem girişi
    window.__FIREBASE_CONFIG__ = fallbackConfig;
    window.__TENANT_ID__ = 'default';
    window.__ROUTER_BASENAME__ = '/';
  }

  // Firebase Config'in __FIREBASE_CONFIG__ üzerinde oturmasını bekledikten sonra
  // uygulamayı Dinamik olarak Import (Lazy) ediyoruz ki firebase.js baştan sabit kalmasın.
  const { default: App } = await import('./App');

  // Dev Cleanup Logic
  if (process.env.NODE_ENV !== 'production') {
    const initDevCleanup = () => {
      try {
        unregisterServiceWorker();
        clearAppCache();
      } catch (e) {
        void e;
      }
    };
    if (document.readyState === 'complete') {
      initDevCleanup();
    } else {
      window.addEventListener('load', initDevCleanup, { once: true });
    }
    const handleChunkError = e => {
      const message = String((e && e.message) || (e && e.reason && e.reason.message) || '');
      if (/ChunkLoadError|Loading chunk/i.test(message)) {
        (async () => {
          try {
            await unregisterServiceWorker();
            await clearAppCache();
          } finally {
            window.location.reload();
          }
        })();
      }
    };
    window.addEventListener('error', handleChunkError);
    window.addEventListener('unhandledrejection', handleChunkError);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter
        basename={window.__ROUTER_BASENAME__}
        future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
      >
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

initializeSaaSApp();
